import { InfoCircleOutlined } from '@ant-design/icons';
import { WarningMessageWrapper } from './styles.js';
import { jsx } from '@emotion/react';
import vars from '../../../styles/custom-properties.js';
import Text from '../../text/text.js';

var WarningMessage = function WarningMessage(_ref) {
  var children = _ref.children;
  return jsx(WarningMessageWrapper, null, jsx(InfoCircleOutlined, {
    style: {
      fontSize: "".concat(vars.fontSize10),
      color: "".concat(vars.colorWarning),
      paddingRight: "".concat(vars.spacingS)
    }
  }), jsx(Text.Body, {
    color: "warning",
    size: "xs"
  }, children));
};
WarningMessage.displayName = 'WarningMessage';

export { WarningMessage };
//# sourceMappingURL=warning-message.js.map
